/* CS Collection — filtros AJAX, sort, load more, quick add */
(function () {
  'use strict';

  var ZONES = ['grid', 'pills', 'count', 'dcount', 'fnum', 'filters'];

  function init(root) {
    if (!root || root.dataset.csColInit) return;
    root.dataset.csColInit = '1';

    var sectionId = root.dataset.sectionId;
    var baseUrl = root.dataset.url || window.location.pathname;
    var gridwrap = root.querySelector('[data-cs-col-zone="grid"]');
    var drawer = root.querySelector('[data-cs-col-drawer]');
    var form = root.querySelector('[data-cs-col-form]');
    var toast = root.querySelector('[data-cs-col-toast]');
    var debounceT = null;
    var toastT = null;

    /* ---------- helpers ---------- */
    function currentSort() {
      var s = root.querySelector('[data-cs-col-sort]');
      if (s) return s.value;
      var p = new URLSearchParams(window.location.search);
      return p.get('sort_by') || '';
    }

    function buildUrl() {
      var params = new URLSearchParams();
      if (form) {
        var fd = new FormData(form);
        fd.forEach(function (v, k) {
          if (String(v).trim() !== '') params.append(k, v);
        });
      }
      var sort = currentSort();
      if (sort) params.set('sort_by', sort);
      var q = params.toString();
      return baseUrl + (q ? '?' + q : '');
    }

    function openStates() {
      if (!form) return [];
      return Array.prototype.map.call(form.querySelectorAll('details'), function (d) { return d.open; });
    }

    function restoreOpenStates(states) {
      if (!form) return;
      var ds = form.querySelectorAll('details');
      states.forEach(function (o, i) { if (ds[i]) ds[i].open = o; });
    }

    function fetchAndSwap(url, push) {
      if (gridwrap) gridwrap.classList.add('is-busy');
      var focusName = null, focusVal = null;
      var ae = document.activeElement;
      if (ae && form && form.contains(ae) && ae.type === 'number') { focusName = ae.name; focusVal = ae.value; }
      var states = openStates();
      var sep = url.indexOf('?') > -1 ? '&' : '?';

      fetch(url + sep + 'section_id=' + sectionId)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          ZONES.forEach(function (z) {
            var cur = root.querySelector('[data-cs-col-zone="' + z + '"]');
            var nxt = doc.querySelector('[data-cs-col-zone="' + z + '"]');
            if (cur && nxt) cur.innerHTML = nxt.innerHTML;
          });
          restoreOpenStates(states);
          if (focusName && form) {
            var inp = form.querySelector('[name="' + focusName + '"]');
            if (inp) { inp.value = focusVal; inp.focus(); }
          }
          if (push !== false) {
            try { history.pushState({ csCol: 1 }, '', url); } catch (e) {}
          }
        })
        .catch(function () { window.location.href = url; })
        .finally(function () { if (gridwrap) gridwrap.classList.remove('is-busy'); });
    }

    function showToast(msg) {
      if (!toast) return;
      toast.textContent = msg || '✓ Adicionado ao carrinho';
      toast.hidden = false;
      requestAnimationFrame(function () { toast.classList.add('is-in'); });
      clearTimeout(toastT);
      toastT = setTimeout(function () {
        toast.classList.remove('is-in');
        setTimeout(function () { toast.hidden = true; }, 220);
      }, 2400);
    }

    /* ---------- density ---------- */
    function applyDens(mode, save) {
      root.classList.remove('dens-lo', 'dens-hi');
      if (mode) root.classList.add('dens-' + mode);
      root.querySelectorAll('[data-cs-col-dens]').forEach(function (b) {
        b.classList.toggle('is-on', b.dataset.csColDens === mode);
      });
      if (save) { try { localStorage.setItem('cs-col-dens', mode || ''); } catch (e) {} }
    }
    var savedDens = '';
    try { savedDens = localStorage.getItem('cs-col-dens') || ''; } catch (e) {}
    if (savedDens === 'lo' || savedDens === 'hi') applyDens(savedDens, false);

    /* ---------- description clamp ---------- */
    var desc = root.querySelector('[data-cs-col-desc]');
    if (desc) {
      var txt = desc.querySelector('[data-cs-col-desc-txt]');
      var btn = desc.querySelector('[data-cs-col-desc-btn]');
      desc.classList.add('is-clamp');
      if (txt && btn && txt.scrollHeight > txt.clientHeight + 4) {
        btn.hidden = false;
        btn.addEventListener('click', function () {
          var clamped = desc.classList.toggle('is-clamp');
          btn.textContent = clamped ? 'Ver mais' : 'Ver menos';
        });
      } else if (txt && txt.scrollHeight <= txt.clientHeight + 4) {
        desc.classList.remove('is-clamp');
      }
    }

    /* ---------- quick add ---------- */
    function quickAdd(btn) {
      var vid = btn.dataset.vid;
      if (!vid) return;
      btn.classList.add('is-busy');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (j) { throw j; });
          return r.json();
        })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cs:cart:add', { detail: { id: vid } }));
          setTimeout(function () {
            var otherOpen = document.querySelector('dialog[open]:not(.cs-col-drawer)');
            if (!otherOpen) showToast('✓ Adicionado ao carrinho');
          }, 450);
        })
        .catch(function (err) {
          showToast((err && err.description) ? err.description : 'Não foi possível adicionar');
        })
        .finally(function () { btn.classList.remove('is-busy'); });
    }

    /* ---------- load more ---------- */
    function loadMore(btn) {
      var next = btn.dataset.nextUrl;
      if (!next) return;
      btn.classList.add('is-busy');
      var sep = next.indexOf('?') > -1 ? '&' : '?';
      fetch(next + sep + 'section_id=' + sectionId)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-cs-col-grid]');
          var curGrid = root.querySelector('[data-cs-col-grid]');
          if (newGrid && curGrid) {
            while (newGrid.firstElementChild) curGrid.appendChild(newGrid.firstElementChild);
          }
          var newMore = doc.querySelector('.cs-col__more');
          var curMore = root.querySelector('.cs-col__more');
          if (curMore) {
            if (newMore) curMore.replaceWith(newMore); else curMore.remove();
          }
        })
        .catch(function () { window.location.href = next; });
    }

    /* infinite scroll */
    if (root.dataset.pagination === 'infinite' && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var b = root.querySelector('[data-cs-col-more]:not(.is-busy)');
          if (b) loadMore(b);
        });
      }, { rootMargin: '600px 0px' });
      var watchMore = function () {
        var m = root.querySelector('.cs-col__more');
        if (m) io.observe(m);
      };
      watchMore();
      new MutationObserver(watchMore).observe(gridwrap || root, { childList: true, subtree: true });
    }

    /* ---------- delegated events ---------- */
    root.addEventListener('click', function (e) {
      var t;
      if ((t = e.target.closest('[data-cs-col-open]'))) {
        if (drawer && !drawer.open) drawer.showModal();
        return;
      }
      if ((t = e.target.closest('[data-cs-col-close]'))) {
        if (drawer && drawer.open) drawer.close();
        return;
      }
      if ((t = e.target.closest('[data-cs-col-ajax]'))) {
        e.preventDefault();
        fetchAndSwap(t.getAttribute('href'));
        return;
      }
      if ((t = e.target.closest('[data-cs-qa]'))) {
        e.preventDefault();
        quickAdd(t);
        return;
      }
      if ((t = e.target.closest('[data-cs-qa-open]'))) {
        e.preventDefault();
        var card = t.closest('.cs-card');
        if (card) {
          var open = card.classList.toggle('qa-open');
          t.setAttribute('aria-expanded', open ? 'true' : 'false');
        }
        return;
      }
      if ((t = e.target.closest('[data-cs-col-more]'))) {
        loadMore(t);
        return;
      }
      if ((t = e.target.closest('[data-cs-col-dens]'))) {
        applyDens(t.dataset.csColDens, true);
        return;
      }
    });

    /* fechar drawer ao clicar no backdrop */
    if (drawer) {
      drawer.addEventListener('click', function (e) {
        if (e.target === drawer) drawer.close();
      });
    }

    /* fechar size picker ao tocar fora (mobile) */
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.cs-card')) {
        root.querySelectorAll('.cs-card.qa-open').forEach(function (c) { c.classList.remove('qa-open'); });
      }
    });

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-cs-col-sort]')) {
        fetchAndSwap(buildUrl());
        return;
      }
      if (form && form.contains(e.target) && e.target.type === 'checkbox') {
        fetchAndSwap(buildUrl());
      }
    });

    root.addEventListener('input', function (e) {
      if (form && form.contains(e.target) && e.target.type === 'number') {
        clearTimeout(debounceT);
        debounceT = setTimeout(function () { fetchAndSwap(buildUrl()); }, 650);
      }
    });

    if (form) {
      form.addEventListener('submit', function (e) { e.preventDefault(); fetchAndSwap(buildUrl()); });
    }

    window.addEventListener('popstate', function () {
      fetchAndSwap(window.location.pathname + window.location.search, false);
    });
  }

  function boot() {
    document.querySelectorAll('[data-cs-col]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-cs-col]');
    if (r) { delete r.dataset.csColInit; init(r); }
  });
})();
